export default __webpack_public_path__ + "static/media/05-1.5ab72fc8.jpg";